import { toApiError } from 'src/utils/api-error';

const MAX_QUERY_RETRIES = 3;

/**
 * Whether TanStack Query should try a failed query again.
 *
 * A 4xx is the server's final answer — the same request will be refused the
 * same way — so retrying it only delays the error the user is waiting for by
 * three backoffs. A 5xx or a request that never got a response (network down,
 * timeout, CORS) is worth another go.
 *
 * The status is read through `toApiError` because it has to work on both
 * shapes: the `ApiError` the auth interceptor rejects with, and the raw
 * AxiosError a request fired before that interceptor was installed still sees.
 */
export function shouldRetryQuery(failureCount: number, error: unknown) {
  const { status } = toApiError(error);

  if (status !== undefined && status >= 400 && status < 500) {
    return false;
  }

  return failureCount < MAX_QUERY_RETRIES;
}
